
/* @ngInject */
export default class ActivationStatusPopupController {
    constructor(DialogService, ToastService, sensors, batchUpdateActivationStatus, AnalyticsService) {
        this.DialogService = DialogService;
        this.ToastService = ToastService;
        this.sensors = sensors;
        this.batchUpdateActivationStatus = batchUpdateActivationStatus;
        this.AnalyticsService = AnalyticsService;

        this.devices = sensors.map(sensor => sensor.name);
        this.updating = false;
        
        // Count active and inactive devices
        this.activeCount = sensors.filter(sensor => sensor.active).length;
        this.inactiveCount = sensors.length - this.activeCount;
        
        // Default action based on majority
        this.activateDevices = this.inactiveCount >= this.activeCount;
    }

    get hasUpdates() {
        return !this.updating;
    }

    update() {
        this.updating = true;
        
        this.batchUpdateActivationStatus({
            devices: this.devices,
            ...(this.activateDevices ? { activateDevices: true } : { deactivateDevices: true })
        })
            .then(() => {
                this.DialogService.hide();
            })
            .finally(() => {
                this.updating = false;
            });
    }

    cancel() {
        this.DialogService.cancel();
    }
} 